export default "__VITE_ASSET__379a7484__"